/* global LanguageExport, ExternalConfigExport */

window.Language = LanguageExport;
window.ExternalConfig = ExternalConfigExport;

export default true;
